module.exports = __webpack_public_path__ + "static/media/213-Sturz-Nicht-Milo_ID_1.e93627b2.mp3";